import React, { useEffect, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faPlus, faSearch } from '@fortawesome/pro-solid-svg-icons';
import { Button, Col, Container, Form, InputGroup, Modal, Row } from 'react-bootstrap';
import './style.scss';
import { Checkbox } from 'primereact/checkbox';
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

const getLocalizedName = (item, languageKey) => item.name[languageKey] || item.name.tr || item.name.en || '';

const matchesSearch = (item, searchValue, languageKey) =>
    getLocalizedName(item, languageKey).toLocaleLowerCase('tr-TR').includes(searchValue);

const AddCriteriaModal = (props) => { // {ratiosList,checkedRatiosItem, predefinedList }
    const { t,i18n } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [selectedRatiosItem, setSelectedRatiosItem] = useState();
    const [activeRatiosItem, setActiveRatiosItem] = useState('scc.10');
    const [selectedCriteria, setSelectedCriteria] = useState([]);
    const [checkedRatiosItem, setCheckedRatiosItem] = useState([]);
    const [predefinedList, setPredefinedList] = useState([]);

    const handleClose = () => setVisible(false);
    const handleShow = () => setVisible(true);
    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    }

    useEffect(() => {
        if (props.ratiosList.length > 0) {
            setSelectedRatiosItem(props.ratiosList[0]);

        }
    }, [props])

    useEffect(() => {
        if (props.predefinedList && props.predefinedList.length > 0) {

            setSelectedCriteria(props.predefinedList);

        }
    }, [props.predefinedList])


    const languageKey = i18n.language.replace("-", "");
    const normalizedSearchValue = searchValue.trim().toLocaleLowerCase('tr-TR');

    const filteredRatiosList = useMemo(() => {
        if (!normalizedSearchValue) {
            return props.ratiosList;
        }

        return props.ratiosList.filter((category) =>
            matchesSearch(category, normalizedSearchValue, languageKey) ||
            category.fields.some((field) => matchesSearch(field, normalizedSearchValue, languageKey))
        );
    }, [props.ratiosList, normalizedSearchValue, languageKey]);

    const selectedRatioFields = useMemo(() => {
        if (!selectedRatiosItem) {
            return [];
        }

        if (!normalizedSearchValue || matchesSearch(selectedRatiosItem, normalizedSearchValue, languageKey)) {
            return selectedRatiosItem.fields;
        }

        return selectedRatiosItem.fields.filter((field) => matchesSearch(field, normalizedSearchValue, languageKey));
    }, [selectedRatiosItem, normalizedSearchValue, languageKey]);

    useEffect(() => {
        if (!normalizedSearchValue || filteredRatiosList.length === 0) {
            return;
        }

        const selectedItemIsVisible = filteredRatiosList.some((item) => item.dataId === selectedRatiosItem?.dataId);

        if (!selectedItemIsVisible) {
            setSelectedRatiosItem(filteredRatiosList[0]);
            setActiveRatiosItem(filteredRatiosList[0].dataId);
        }
    }, [filteredRatiosList, normalizedSearchValue, selectedRatiosItem]);

    const selectedItem = (item) => {
        // console.log(item);
        setSelectedRatiosItem(item);
        setActiveRatiosItem(item.dataId);

    }


    const onIngredientsChange = (e, item) => {
        console.log('onIngredientsChange item:', item);

        let _selecedCriteria = [...selectedCriteria];

        if (e.checked) {
            // _selecedCriteria.push(e.value);
            _selecedCriteria.push(
                {
                    id: e.value,
                    name: item.name,
                    checked: true
                }
            )
        }
        else {
            _selecedCriteria = _selecedCriteria.filter(x => x.id !== e.value);
        }
        setSelectedCriteria(_selecedCriteria);

    }

    const saveButton = () => {
        // console.log('saveButton');

        setCheckedRatiosItem(selectedCriteria);
        props.checkedRatiosItem(selectedCriteria);
        handleClose();
    }

    return (
        <div className="add-criteria-modal" >
            <div onClick={() => handleShow(true)}>
                <FontAwesomeIcon className='add-criteria-icon' icon={faPlus} />
                <label className='p-l-5 roboto-medium-16 add-criteria-button '>
                    {t(('addCriteria'))}
                </label>
            </div>


            <Modal show={visible} onHide={handleClose}
                className='criteria-modal'
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Modal.Header className='modal-header'>
                    <Container className='container'>
                        <Row className='header-row cursor-pointer'>
                            <Col md="11" className='color-text roboto-bold-18 title'>
                                <label>{t(('ratios'))}</label>
                            </Col>
                            <Col md="1"><FontAwesomeIcon data-testid="close-icon-button" className='modalCloseIcon text-align-right float-right' icon={faCircleXmark} onClick={handleClose} /></Col>
                        </Row>
                    </Container>
                </Modal.Header>

                <Modal.Body className='criteria-modal p-0'>
                    <Container className='modalBodyContainer p-0'>
                        <Row>
                            <Col md="12" className='p-lr-30 p-t-20 p-b-20 input-group-col'>
                                <InputGroup className="search-input-group mx-auto" data-testid="search-input">
                                    <InputGroup.Text id="inputGroup-sizing-default">
                                        <FontAwesomeIcon icon={faSearch} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        className='search-input'
                                        aria-label="Default"
                                        aria-describedby="inputGroup-sizing-default"
                                        placeholder="Ara"
                                        value={searchValue}
                                        onChange={(e) => handleSearchChange(e)}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>

                        <div className='divider-line' />

                        <Row className='ratios-content-row'>
                            <Col md='4' className='ratios-list-col  p-t-0 p-b-0'  >
                                {
                                    filteredRatiosList.map((item, index) => {
                                        return (
                                            <div className={`list-item ${activeRatiosItem === item.dataId ? 'active' : ''}`}
                                                key={item.dataId} onClick={() => selectedItem(item)}>
                                                <label className=' p-lr-15 roboto-medium-14'>{item.name[i18n.language.replace("-","")]}</label>
                                                <label className='list-arrow-icon'>
                                                    <FontAwesomeIcon className='list-detail-icon text-align-right float-right cursor-pointer' icon={faAngleRight} onClick={handleClose} />
                                                </label>
                                            </div>
                                        )
                                    })
                                }
                            </Col>

                            <Col md='8' className='ratios-select-list-col  p-t-10 p-b-0'  >
                                <div>
                                    {
                                        selectedRatiosItem &&
                                        filteredRatiosList.length > 0 &&
                                        <label className='ratios-title roboto-medium-16'>
                                            {selectedRatiosItem.name[i18n.language.replace("-","")]}
                                        </label>
                                    }

                                    <div className='list-div'>
                                        {filteredRatiosList.length === 0 && normalizedSearchValue ? (
                                            <div className='no-search-results roboto-medium-14'>
                                                {t('noSearchResults')}
                                            </div>
                                        ) : (
                                            selectedRatiosItem != null &&
                                            selectedRatioFields.map((item, index) =>
                                                <div key={item.dataId} className="flex flex-wrap justify-content-left ml-1 p-t-10 p-b-10">
                                                    <div className="flex align-items-center">
                                                        <Checkbox inputId={item.dataId} name={item.name[i18n.language.replace("-","")]} value={item.dataId} onChange={(event) => onIngredientsChange(event, item)} checked={selectedCriteria.some(ingredient => ingredient.id === item.dataId && ingredient.checked)} />
                                                        <label htmlFor={item.dataId} className="ml-3 color-text roboto-medium-14">{item.name[i18n.language.replace("-","")]}</label>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </Col>

                        </Row>
                    </Container>

                </Modal.Body>

                <Modal.Footer className='modalFooter'>
                    <Container>
                        <Row>

                            <Col md='12'>
                                <Button className='save-button roboto-regular-18' variant="primary" onClick={saveButton}>
                                    <label className='text-align-center'>
                                        {t('apply')}
                                    </label>
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Footer>

            </Modal>


        </div>


    )


}

export default AddCriteriaModal;

